import { useState } from 'react';
import { ThemeConsumer } from 'styled-components';
import { Switch } from '@headlessui/react';

export default function ToggleModeSwitch() {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="py-1">
      <ThemeConsumer>
        {(theme) => (
          <Switch
            checked={enabled}
            onChange={(e) => {
              setEnabled(!enabled);
              theme.setTheme(
                theme.mode === 'dark'
                  ? { ...theme, mode: 'light' }
                  : { ...theme, mode: 'dark' }
              );
            }}
            className={`${enabled ? 'bg-slate-200' : 'bg-purple-200'}
              relative inline-flex h-[25px] w-[40px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            <span
              aria-hidden="true"
              className={`${enabled ? 'translate-x-4' : 'translate-x-0'}
                pointer-events-none inline-block h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
            />
          </Switch>
        )}
      </ThemeConsumer>
    </div>
  );
}
